/**
 * Smooth height transitions for accordions (<details>):
 * - Collapsible content section (.collapsible-content)
 * - Combined product page tabs (.combined-product__tabs)
 * - FAQ section (.faq__accordion)
 *
 * We animate the immediate panel after <summary> by transitioning its `height`.
 */
(function () {
  if (window.__kizenCollapsibleContentAccordion) return;
  window.__kizenCollapsibleContentAccordion = true;

  const DURATION_MS = 300;
  const EASING = 'cubic-bezier(.2,.8,.2,1)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isSupportedDetails(details) {
    if (!details) return false;
    return !!(
      details.closest('.collapsible-content') ||
      details.closest('.combined-product__tabs') ||
      details.closest('.faq__accordion')
    );
  }

  function getPanel(details) {
    const summary = details.querySelector(':scope > summary');
    const panel = summary?.nextElementSibling;
    return panel || null;
  }

  function prepPanel(panel) {
    panel.style.overflow = 'hidden';
    panel.style.willChange = 'height';
    panel.style.transition = `height ${DURATION_MS}ms ${EASING}`;
    panel.style.boxSizing = 'border-box';
  }

  function cleanupPanel(panel) {
    panel.style.removeProperty('overflow');
    panel.style.removeProperty('willChange');
    panel.style.removeProperty('transition');
    panel.style.removeProperty('boxSizing');
  }

  function animateOpen(details, panel) {
    details.setAttribute('open', '');
    prepPanel(panel);
    panel.style.height = '0px';
    // force style flush
    void panel.offsetHeight;
    panel.style.height = `${panel.scrollHeight}px`;

    const done = () => {
      panel.removeEventListener('transitionend', onEnd);
      panel.style.height = 'auto';
      cleanupPanel(panel);
      delete details.dataset.kizenAccBusy;
    };

    const onEnd = (ev) => {
      if (ev.target !== panel || ev.propertyName !== 'height') return;
      done();
    };

    details.dataset.kizenAccBusy = '1';
    panel.addEventListener('transitionend', onEnd);
    window.setTimeout(done, DURATION_MS + 80);
  }

  function animateClose(details, panel) {
    prepPanel(panel);
    const current = panel.getBoundingClientRect().height;
    panel.style.height = `${current}px`;
    void panel.offsetHeight;
    panel.style.height = '0px';

    const done = () => {
      panel.removeEventListener('transitionend', onEnd);
      details.removeAttribute('open');
      panel.style.removeProperty('height');
      cleanupPanel(panel);
      delete details.dataset.kizenAccBusy;
    };

    const onEnd = (ev) => {
      if (ev.target !== panel || ev.propertyName !== 'height') return;
      done();
    };

    details.dataset.kizenAccBusy = '1';
    panel.addEventListener('transitionend', onEnd);
    window.setTimeout(done, DURATION_MS + 80);
  }

  function groupRootFor(details) {
    return (
      details.closest('.faq__accordion') ||
      details.closest('.collapsible-content') ||
      details.closest('[id^="shopify-section-"]') ||
      details.parentElement
    );
  }

  function closeOthers(details) {
    const root = groupRootFor(details);
    if (!root) return;
    root.querySelectorAll('details[open]').forEach((other) => {
      if (other === details) return;
      if (!isSupportedDetails(other)) return;
      if (other.dataset.kizenAccBusy === '1') return;
      const panel = getPanel(other);
      if (!panel) return;
      animateClose(other, panel);
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      if (prefersReducedMotion()) return;

      const summary = e.target.closest(
        '.collapsible-content details > summary, .combined-product__tabs details > summary, .faq__accordion details > summary'
      );
      if (!summary) return;

      const details = summary.closest('details');
      if (!details || !isSupportedDetails(details)) return;
      if (details.dataset.kizenAccBusy === '1') return;

      const panel = getPanel(details);
      if (!panel) return;

      e.preventDefault();

      const isOpen = details.hasAttribute('open');
      if (isOpen) {
        animateClose(details, panel);
      } else {
        closeOthers(details);
        animateOpen(details, panel);
      }
    },
    true
  );
})();
